import { TextLegacy } from '@/components/common'
import { RouteType } from '@/components/common/buttons/LinkButton'
import Table from '@/components/common/table/table'
import { FontResponsiveSizeType } from '@/components/common/texts/TextBase'
import LinkButtonGotoPolicyPage from '@/components/domains/policy/LinkButtonGotoPolicyPage'
import { ENV_CONFIG } from '@/constants/env/config'
import { HospitalListUrl } from '@/constants/hospital-url.const'
import ROUTES from '@/constants/legacy/constRoutes'

const PolicyProvide3rd = ({
  fontSize = { xs: 12, md: 14 },
  strongFontSize = { xs: 14, md: 16 },
  routeType = 'push',
  paddingTop = 40,
  openNewWindow = false,
}: {
  fontSize?: FontResponsiveSizeType
  strongFontSize?: FontResponsiveSizeType
  routeType?: RouteType
  paddingTop?: number
  openNewWindow?: boolean
}) => {
  const columnsPersonalInfo = [
    {
      title: '제공 받는자',
      dataIndex: 'recipient',
      key: 'recipient',
      width: '20%',
    },
    {
      title: '이용 목적',
      dataIndex: 'purpose',
      key: 'purpose',
      width: '30%',
    },
    {
      title: '제공 항목',
      dataIndex: 'offer',
      key: 'offer',
      width: '30%',
    },
    {
      title: '보유기간',
      dataIndex: 'period',
      key: 'period',
      width: '20%',
    },
  ]
  const dataSourcePersonalInfo = [
    {
      key: 1,
      recipient: (
        <TextLegacy
          size={strongFontSize}
          style={{
            display: 'inline',
            fontWeight: 'bold',
            textDecoration: 'underline',
            textUnderlinePosition: 'under',
          }}
        >
          핏펫 제휴 수의사
        </TextLegacy>
      ),
      purpose: (
        <TextLegacy
          size={strongFontSize}
          style={{
            display: 'inline',
            fontWeight: 'bold',
            textDecoration: 'underline',
            textUnderlinePosition: 'under',
          }}
        >
          상담 서비스 제공, 병원 연계 진행, 반려동물 정보 확인
        </TextLegacy>
      ),
      offer: (
        <>
          [회원 정보]
          <br />
          성명, 생년월일, 성별, 휴대전화번호, 상담 정보
          <br />
          [반려동물 정보]
          <br />
          종류, 성별, 이름, 나이, 몸무게, 품종, 중성화 여부
        </>
      ),
      period: (
        <>
          <TextLegacy
            size={strongFontSize}
            style={{
              display: 'inline',
              fontWeight: 'bold',
              textDecoration: 'underline',
              textUnderlinePosition: 'under',
            }}
          >
            동의철회 또는 회원 탈퇴시까지
          </TextLegacy>{' '}
          <br />
          <TextLegacy size={fontSize} style={{ display: 'inline' }}>
            ※단, 법정 의무 보유기간에 따라 보관
          </TextLegacy>
        </>
      ),
    },
    {
      key: 2,
      recipient: (
        <>
          <TextLegacy
            size={strongFontSize}
            style={{
              display: 'inline',
              fontWeight: 'bold',
              textDecoration: 'underline',
              textUnderlinePosition: 'under',
            }}
          >
            핏펫 제휴 동물병원 및 병원 제휴 중개업체
            <br />[
          </TextLegacy>
          <LinkButtonGotoPolicyPage
            text="링크 참조"
            url={HospitalListUrl}
            fontSize={strongFontSize}
            routeType={routeType}
            openNewWindow={openNewWindow}
          />
          <TextLegacy
            size={strongFontSize}
            style={{
              display: 'inline',
              fontWeight: 'bold',
              textDecoration: 'underline',
              textUnderlinePosition: 'under',
            }}
          >
            {']'}
          </TextLegacy>
        </>
      ),
      purpose: (
        <TextLegacy
          size={strongFontSize}
          style={{
            display: 'inline',
            fontWeight: 'bold',
            textDecoration: 'underline',
            textUnderlinePosition: 'under',
          }}
        >
          병원예약 서비스 진행
        </TextLegacy>
      ),
      offer: (
        <>
          [회원 정보]
          <br />
          이름, 휴대전화번호, 생년월일
          <br />
          [반려동물 정보]
          <br />
          종류, 성별, 이름, 나이, 몸무게, 품종, 중성화 여부
        </>
      ),
      period: (
        <>
          <TextLegacy
            size={strongFontSize}
            style={{
              display: 'inline',
              fontWeight: 'bold',
              textDecoration: 'underline',
              textUnderlinePosition: 'under',
            }}
          >
            동의철회 또는 회원 탈퇴시까지
          </TextLegacy>{' '}
          <br />
          <TextLegacy size={fontSize} style={{ display: 'inline' }}>
            ※단, 법정 의무 보유기간에 따라 보관
          </TextLegacy>
        </>
      ),
    },
    {
      key: 3,
      recipient: (
        <>
          <TextLegacy
            size={strongFontSize}
            style={{
              display: 'inline',
              fontWeight: 'bold',
              textDecoration: 'underline',
              textUnderlinePosition: 'under',
            }}
          >
            핏펫 판매자(셀러)
            <br />[
          </TextLegacy>
          <LinkButtonGotoPolicyPage
            text="링크 참조"
            url={`${ENV_CONFIG.fitpetmallHost}${ROUTES.POLICY.SELLERS}`}
            fontSize={strongFontSize}
            routeType={routeType}
            openNewWindow={openNewWindow}
          />
          <TextLegacy
            size={strongFontSize}
            style={{
              display: 'inline',
              fontWeight: 'bold',
              textDecoration: 'underline',
              textUnderlinePosition: 'under',
            }}
          >
            {']'}
          </TextLegacy>
        </>
      ),
      purpose: (
        <TextLegacy
          size={strongFontSize}
          style={{
            display: 'inline',
            fontWeight: 'bold',
            textDecoration: 'underline',
            textUnderlinePosition: 'under',
          }}
        >
          상품(서비스) 배송(전송), 반품, 환불, 고객상담 등 구매계약의 이행을 위해 필요한 업무의 처리
        </TextLegacy>
      ),
      offer: '이름, 휴대전화번호, 배송주소, 주문정보 (구매자와 수취인이 다를 경우는 수취인의 정보가 함께 제공됩니다)',
      period: (
        <>
          <TextLegacy
            size={strongFontSize}
            style={{
              display: 'inline',
              fontWeight: 'bold',
              textDecoration: 'underline',
              textUnderlinePosition: 'under',
            }}
          >
            동의철회 또는 회원 탈퇴시까지
          </TextLegacy>
          <br />
          <TextLegacy size={fontSize} style={{ display: 'inline' }}>
            ※단, 법정 의무 보유기간에 따라 보관
          </TextLegacy>
        </>
      ),
    },
    {
      key: 4,
      recipient: (
        <>
          <TextLegacy
            size={strongFontSize}
            style={{
              display: 'inline',
              fontWeight: 'bold',
              textDecoration: 'underline',
              textUnderlinePosition: 'under',
            }}
          >
            DB손해보험 주식회사
            <br />
          </TextLegacy>
        </>
      ),
      purpose: (
        <TextLegacy
          size={strongFontSize}
          style={{
            display: 'inline',
            fontWeight: 'bold',
            textDecoration: 'underline',
            textUnderlinePosition: 'under',
          }}
        >
          DB손해보험 펫보험 가입자 본인 확인, 원활한 거래 진행, 서비스 분석과 통계에 따른 혜택 및 맞춤 서비스 제공,
          민원처리 등 고객상담, 고객관리, 분쟁조정을 위한 기록 보존
        </TextLegacy>
      ),
      offer: '(휴대)전화번호',
      period: (
        <>
          <TextLegacy
            size={strongFontSize}
            style={{
              display: 'inline',
              fontWeight: 'bold',
              textDecoration: 'underline',
              textUnderlinePosition: 'under',
            }}
          >
            위 개인정보 이용목적 달성 시 까지
          </TextLegacy>
        </>
      ),
    },
  ]

  return (
    <div style={{ padding: 10, paddingTop: paddingTop }}>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {'㈜핏펫은 다음과 같이 귀하의 개인정보를 제3자에게 제공하고자 합니다.'}
      </TextLegacy>
      <Table
        data={dataSourcePersonalInfo}
        columns={columnsPersonalInfo}
        style={{ paddingTop: 10, paddingBottom: 10 }}
      />
      <TextLegacy
        size={fontSize}
        style={{
          display: 'inline',
          fontWeight: 'bold',
        }}
      >
        귀하는 위의 개인정보 제3자 제공에 대해 동의를 거부할 권리가 있습니다.
      </TextLegacy>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        그러나 동의를 거부할 경우 각종 핏펫 제휴 서비스 제공이 제한될 수 있습니다.
        <br />
        위와 같이 개인정보를 제3자에게 제공하는 것에 동의하십니까?
      </TextLegacy>
    </div>
  )
}

export default PolicyProvide3rd
